import Vue from "vue";
import _ from "lodash";
import API from "@/api/index";

const MODULE_NAME = "vu_approach_location";

const MUTATION_TYPES = {
	UPDATE_VU_APPROACH_LOCATION: "UPDATE_VU_APPROACH_LOCATION"
};

const ACTION_TYPES = {
	LOAD_VU_APPROACH_LOCATION: "LOAD_VU_APPROACH_LOCATION"
};

export default {
	MODULE_NAME,
	MUTATION_TYPES,
	ACTION_TYPES,
	namespaced: true,
	state: {
		vuApproachLocations: {}
	},
	mutations: {
		[MUTATION_TYPES.UPDATE_VU_APPROACH_LOCATION](state, payload) {
			if (!(payload && _.isObject(payload))) {
				throw new Error(
					`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_VU_APPROACH_LOCATION}: Invalid or missing payload.`
				);
			}
			const data =
				(!_.isUndefined(payload.vuApproachLocation) &&
					payload.vuApproachLocation) ||
				(!_.isUndefined(payload.data) && payload.data) ||
				payload;
			const vuApproachLocationId =
				data.vuApproachLocationid ||
				data.vuApproachLocationId ||
				data.VUApproachLocationId ||
				payload.vuApproachLocationId ||
				payload.VUApproachLocationId ||
				payload.id;
			if (!vuApproachLocationId) {
				throw new Error(
					`${MODULE_NAME}/${MUTATION_TYPES.UPDATE_VU_APPROACH_LOCATION}: Invalid or missing vuApproachLocation id.`
				);
			}
			Vue.set(state.vuApproachLocations, vuApproachLocationId, data);
		}
	},
	actions: {
		[ACTION_TYPES.LOAD_VU_APPROACH_LOCATION](context, payload) {
			const vuApproachLocationId = parseInt(
				_.isObject(payload)
					? payload.vuApproachLocationid ||
							payload.vuApproachLocationId ||
							payload.VUApproachLocationId ||
							payload.id
					: payload,
				10
			);
			if (!vuApproachLocationId && _.isObject(payload)) {
				// Try loading
			}
			return new Promise((resolve, reject) => {
				if (!vuApproachLocationId) {
					return reject(
						new Error(
							`${MODULE_NAME}/${ACTION_TYPES.LOAD_VU_APPROACH_LOCATION}: Invalid or missing vuApproachLocation id.`
						)
					);
				}
				if (_.isUndefined(context.getters.byIdentifier(vuApproachLocationId))) {
					// Hit API
					return resolve(
						API.getWithParamsJson(
							API.ENDPOINTS
								.SELECT_VU_APPROACH_LOCATION_BY_VU_APPROACH_LOCATION_ID,
							{ vuApproachLocationId },
							{},
							e => {
								throw e;
							}
						)
					);
				} else {
					return resolve(context.getters.byIdentifier(vuApproachLocationId));
				}
			})
				.then(result => {
					if (_.isEmpty(result)) {
						throw new Error(
							`${MODULE_NAME}.${ACTION_TYPES.LOAD_VU_APPROACH_LOCATION}: Falsy server response for vuApproachLocationId "${vuApproachLocationId}".`
						);
					}
					return result;
				})
				.catch(e => {
					console.warn(e);
					return { vuApproachLocationId, vuApproachLocation: null };
				})
				.then(result => {
					if (_.isArray(result)) result = result[0];
					try {
						context.commit(
							`${MUTATION_TYPES.UPDATE_VU_APPROACH_LOCATION}`,
							result
						);
					} catch (e) {
						console.warn(
							`${MODULE_NAME}.${ACTION_TYPES.LOAD_VU_APPROACH_LOCATION}`,
							e,
							vuApproachLocationId,
							result
						);
					}
					return context.getters.byIdentifier(vuApproachLocationId);
				});
		}
	},
	getters: {
		all(state) {
			return state.vuApproachLocations;
		},
		byIdentifier(state) {
			return vuApproachLocationId =>
				state.vuApproachLocations[vuApproachLocationId];
		}
	}
};
